import React, { useEffect, useState } from 'react';
import { Alert, MenuItem, Stack, TextField } from '@mui/material';
import api from '../services/api';

export interface NextManagerVersion { version: number; name: string; maxUsers: number; maxMachines: number; modules: number[]; licenseCount: number }
export const limitsText = (v: { maxUsers: number; maxMachines: number }) =>
  `${v.maxUsers} ${v.maxUsers === 1 ? 'utente' : 'utenti'} · ${v.maxMachines} ${v.maxMachines === 1 ? 'macchina' : 'macchine'}`;

export default function NextManagerVersionSelector({ version, onChange, error }: {
  version?: number | null; onChange: (version: number, name: string) => void; error?: string;
}) {
  const [versions, setVersions] = useState<NextManagerVersion[]>([]);
  const [loadError, setLoadError] = useState('');
  useEffect(() => {
    let current = true;
    api.get('/software-licenses/next-manager/versions').then(result => {
      if (current) setVersions(result.data.data.versions);
    }).catch(() => { if (current) setLoadError('Impossibile caricare le versioni di NEXT Manager.'); });
    return () => { current = false; };
  }, []);
  return <Stack spacing={1.5}>
    {loadError && <Alert severity="error">{loadError}</Alert>}
    <TextField select fullWidth required label="Versione acquistata" value={versions.length ? version ?? '' : ''}
      error={!!error} helperText={error || 'I limiti di utenti e macchine sono quelli della versione. Aggiornamenti e assistenza sono coperture separate.'}
      onChange={e => { const chosen = versions.find(v => v.version === Number(e.target.value)); if (chosen) onChange(chosen.version, chosen.name); }}>
      {versions.map(v => <MenuItem key={v.version} value={v.version}>{v.version} · {v.name} · {limitsText(v)}</MenuItem>)}
    </TextField>
    <Alert severity="info">Le modifiche si applicano al rinnovo del certificato. Un server offline conserva i diritti già firmati fino alla scadenza del certificato.</Alert>
  </Stack>;
}
